import "bootstrap/dist/css/bootstrap.min.css";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "bootstrap";

import "video.js/dist/video-js.min.css";
import "@/assets/home-styles.css";
import "@fortawesome/fontawesome-free/css/all.min.css";


Vue.config.productionTip = false;


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");